import { useState } from "react";
import {
  Button,
  Modal,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useDeleteCity } from "@/features/city/use-cities.ts";

export function DeleteCityModal({ cityId }: { cityId: number }) {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync, isPending } = useDeleteCity();

  return (
    <div>
      <Button
        isIconOnly
        variant="danger-soft"
        onPress={() => setIsOpen(true)}
      >
        <Icon className="size-6" icon="solar:trash-bin-minimalistic-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>Подтверждение</Modal.Heading>
              </Modal.Header>
              <Modal.Body>Удалить город?</Modal.Body>
              <Modal.Footer>
                <Button
                    variant="ghost"
                    onPress={() => setIsOpen(false)}
                >
                  Нет, назад
                </Button>

                <Button
                    variant="danger"
                    isPending={isPending}
                    type="submit"
                    onPress={() => mutateAsync({ id: cityId })}
                >
                  Да, удалить
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
